/* @generated from adl module ferovinum.sourcecontracts.purchaserequestadditionalcost */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.purchase_request_additional_cost` contract.
 */
export interface PurchaseRequestAdditionalCostSource {
  id: ferovinum_app_db.PurchaseRequestAdditionalCostId;
  purchaseRequestId: ferovinum_app_db.PurchaseRequestId;
  amount: common.BigDecimal;
  description: common_strings.StringNE;
  costType: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makePurchaseRequestAdditionalCostSource(
  input: {
    id: ferovinum_app_db.PurchaseRequestAdditionalCostId,
    purchaseRequestId: ferovinum_app_db.PurchaseRequestId,
    amount: common.BigDecimal,
    description: common_strings.StringNE,
    costType: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): PurchaseRequestAdditionalCostSource {
  return {
    id: input.id,
    purchaseRequestId: input.purchaseRequestId,
    amount: input.amount,
    description: input.description,
    costType: input.costType,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const PurchaseRequestAdditionalCostSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.purchaserequestadditionalcost","decl":{"annotations":[{"value":{"modelName":"source__app_db.purchase_request_additional_cost","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.purchase_request_additional_cost` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestAdditionalCostId"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaseRequestId","default":{"kind":"nothing"},"name":"purchaseRequestId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"costType","default":{"kind":"nothing"},"name":"costType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"PurchaseRequestAdditionalCostSource","version":{"kind":"nothing"}}};

export const snPurchaseRequestAdditionalCostSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.purchaserequestadditionalcost", name:"PurchaseRequestAdditionalCostSource"};

export function texprPurchaseRequestAdditionalCostSource(): ADL.ATypeExpr<PurchaseRequestAdditionalCostSource> {
  return {value : {typeRef : {kind: "reference", value : snPurchaseRequestAdditionalCostSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.purchaserequestadditionalcost.PurchaseRequestAdditionalCostSource" : PurchaseRequestAdditionalCostSource_AST
};
